<div id="incepted-ape-container">
    <div id="incepted-ape-card-container" class="container-fluid">
        <!-- <div id="incepted-ape-header">
            <h5 class="page-header">Incepted APE</h5>
        </div> -->

        <div id="incepted-ape-card-body" class="row">
            <div id="incepted-ape-month-to-date" class="col-sm-12 col-md-10 col-lg-6 col-xxl-6 ape-card-container">
                <mat-card appearance="raised" class="ape-card">
                    <mat-card-header class="ape-card-header">
                        <mat-card-title class="ape-card-title">Incepted APE (Month to Date)</mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="ape-card-content">
                        <div class="row ape-card-content-container">
                            <div class="col-6 ape-card-content-left-border">
                                <div class="ape-card-content-header">Singlife</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.monthSinglife |
                                    currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                                <div class="mt-2"></div>
                                <div class="ape-card-content-header">Case</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.monthSinglifeCase}}
                                </div>
                            </div>
                            <div class="col-6 ape-card-content">
                                <div class="ape-card-content-header">Non-Singlife</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.monthNonsinglife |
                                    currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                                <div class="mt-2"></div>
                                <div class="ape-card-content-header">Case</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.monthNonsinglifeCase}}
                                </div>
                            </div>
                        </div>
                        <div class="row ape-card-content-container">
                            <div class="ape-card-divider"></div>
                            <div class="ape-card-content">
                                <div class="ape-card-content-total-value">{{this.totalMonthInceptedApe | currency:
                                    'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div id="incepted-ape-year-to-date" class="col-sm-12 col-md-10 col-lg-6 col-xxl-6 ape-card-container">
                <mat-card appearance="raised" class="ape-card">
                    <mat-card-header class="ape-card-header">
                        <mat-card-title class="ape-card-title">Incepted APE (Year to Date)</mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="ape-card-content">
                        <div class="row ape-card-content-container">
                            <div class="col-6 ape-card-content-left-border">
                                <div class="ape-card-content-header">Singlife</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.yearSinglife |
                                    currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                                <div class="mt-2"></div>
                                <div class="ape-card-content-header">Case</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.yearSinglifeCase}}
                                </div>
                            </div>
                            <div class="col-6 ape-card-content">
                                <div class="ape-card-content-header">Non-Singlife</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.yearNonsinglife |
                                    currency: 'SGD' : 'symbol-narrow' : '1.0-0'}}
                                </div>
                                <div class="mt-2"></div>
                                <div class="ape-card-content-header">Case</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.yearNonsinglifeCase}}
                                </div>
                            </div>
                        </div>
                        <div class="row ape-card-content-container">
                            <div class="ape-card-divider"></div>
                            <div class="ape-card-content">
                                <div class="ape-card-content-total-value">{{this.totalYearInceptedApe | currency:
                                    'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                            </div>
                        </div>
                        @if (this.currentUserRole === 'Corporate') {
                        <div class="row ape-card-content-container">
                            <div class="ape-card-divider"></div>
                            <div class="col-6 ape-card-content-left-border">
                                <div class="ape-card-content-header">2025 Target</div>
                                <div class="ape-card-content-value">{{this.inceptedApeSummary.yearTarget | currency:
                                    'SGD' : 'symbol-narrow' : '1.0-0'}}</div>
                            </div>
                            <div class="col-6 ape-card-content">
                                <div class="ape-card-content-header">Shortfall / Overachieve</div>
                                @if(this.totalYearInceptedApe >= this.inceptedApeSummary.yearTarget) {
                                <div class="ape-card-content-value-green">
                                    {{(this.totalYearInceptedApe - this.inceptedApeSummary.yearTarget) | currency:
                                    'SGD' : 'symbol-narrow' : '1.0-0'}}
                                </div>
                                }
                                @else {
                                <div class="ape-card-content-value-red">
                                    {{(this.inceptedApeSummary.yearTarget - this.totalYearInceptedApe) | currency:
                                    'SGD' : 'symbol-narrow' : '1.0-0'}}
                                </div>
                                }
                            </div>
                        </div>
                        }
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>

    <!-- Incepted APE list -->

    <!-- Incepted APE By Managers -->
    <div id="incepted-ape-by-manager-table-container" class="container-fluid"
        [hidden]="this.isInceptedApeByManagerTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="incepted-ape-by-manager-table-exapansion-panel" [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title id="incepted-ape-by-manager-table-exapansion-header">
                        <h5 class="page-header">Incepted APE (By Manager)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="position-relative" style="max-width: 500px">
                    <input type="type" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeByManagerTableFilterFc"
                        (keyup)="__applyInceptedApeByManagerDataFilter()" placeholder="Search managers..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="inceptedApeByManagerTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearManagerSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <mat-divider class="pias-divider"></mat-divider>

                <!-- Incepted APE Manager Data List table -->
                <div id="incepted-ape-by-manager-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="inceptedApeByManagerTableDataSource" matSort matSortDisableClear
                        matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByManagerTableSort="matSort"
                        class="custom-mat-table">

                        <!-- Rep Code Column (rowspan=2) -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 100px;">
                                {{apeData.repCode}}
                                <!-- <a class="branch-popup-link"
                                    (click)="__displayManagerWiseAdvisors(apeData.repCode, apeData.personName)">
                                    {{apeData.repCode}} </a> -->
                            </td>
                        </ng-container>

                        <!-- Person Name Column (rowspan=2) -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 150px;">
                                <a class="branch-popup-link"
                                    (click)="__displayManagerWiseAdvisors(apeData.repCode, apeData.personName)">
                                    {{apeData.personName}} </a>
                            </td>
                        </ng-container>

                        <!-- Branch Name Column (rowspan=2) -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;"> {{apeData.branch}} </td>
                        </ng-container>

                        <!-- Header Row2 month singlife group -->
                        <ng-container matColumnDef="header-row2-month-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 month nonsinglife group -->
                        <ng-container matColumnDef="header-row2-month-nonsinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Non-Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year singlife group -->
                        <ng-container matColumnDef="header-row2-year-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year nonsinglife group -->
                        <ng-container matColumnDef="header-row2-year-nonsinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Non-Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Year Total Column (rowspan=2) -->
                        <ng-container matColumnDef="yearTotal">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Year Total </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{ apeData.yearTotal |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife APE Column -->
                        <ng-container matColumnDef="monthSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthSinglife | currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife Case Column -->
                        <ng-container matColumnDef="monthSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Month Non-Singlife APE Column -->
                        <ng-container matColumnDef="monthNonsinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthNonsinglife |
                                currency: 'SGD'
                                : 'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Non-Singlife Case Column -->
                        <ng-container matColumnDef="monthNonsinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthNonsinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Singlife APE Column -->
                        <ng-container matColumnDef="yearSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearSinglife | currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Singlife Case Column -->
                        <ng-container matColumnDef="yearSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Non-Singlife APE Column -->
                        <ng-container matColumnDef="yearNonsinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearNonsinglife |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Non-Singlife Case Column -->
                        <ng-container matColumnDef="yearNonsinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearNonsinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- First Header Row (with Rep Code, Name, Group Headers, and Year Total) -->
                        <tr mat-header-row *matHeaderRowDef="inceptedApeByManagerTableDisplayFirstColumn; sticky: true">
                        </tr>

                        <!-- Second Header Row (with only APE and Case subheaders) -->
                        <tr mat-header-row
                            *matHeaderRowDef="inceptedApeByManagerTableDisplaySecondColumn; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: inceptedApeByManagerTableDisplayDataRow;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="11">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Incepted APE Data Table Paginator -->
                    <mat-paginator #inceptedApeByManagerTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of incepted APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- Incepted APE By Advisors-->
    <div id="incepted-ape-by-advisor-table-container" class="container-fluid"
        [hidden]="isInceptedApeByAdvisorTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="incepted-ape-by-advisor-table-exapansion-panel" [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title id="incepted-ape-by-advisor-table-exapansion-header">
                        <h5 class="page-header">Incepted APE (By advisor)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Incepted APE (By advisor) Data Filtering-->
                <!-- <div class="w-100">
                    <mat-form-field class="w-100">
                        <mat-label>Search Incepted APE (By advisor)</mat-label>
                        <input matInput [formControl]="inceptedApeByAdvisorTableFilterFc"
                            (keyup)="__applyInceptedApeByAdvisorDataFilter()" placeholder="Ex. Rep. Code, name" #input>
                    </mat-form-field>
                </div> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="type" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeByAdvisorTableFilterFc"
                        (keyup)="__applyInceptedApeByAdvisorDataFilter()" placeholder="Search advisors..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="inceptedApeByAdvisorTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Incepted APE Data List table -->
                <div id="incepted-ape-by-advisor-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="inceptedApeByAdvisorTableDataSource" matSort matSortDisableClear
                        matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByAdvisorTableSort="matSort"
                        class="custom-mat-table">

                        <!-- Rep Code Column (rowspan=2) -->
                        <ng-container matColumnDef="repCode">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Rep. Code </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 100px;"> {{apeData.repCode}} </td>
                        </ng-container>

                        <!-- Person Name Column (rowspan=2) -->
                        <ng-container matColumnDef="personName">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Name </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 150px;">
                                {{apeData.personName}} </td>
                        </ng-container>

                        <!-- Branch Name Column (rowspan=2) -->
                        <ng-container matColumnDef="branch">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;"> {{apeData.branch}} </td>
                        </ng-container>

                        <!-- Header Row2 month singlife group -->
                        <ng-container matColumnDef="header-row2-month-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 month nonsinglife group -->
                        <ng-container matColumnDef="header-row2-month-nonsinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Non-Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year singlife group -->
                        <ng-container matColumnDef="header-row2-year-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year nonsinglife group -->
                        <ng-container matColumnDef="header-row2-year-nonsinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Non-Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Year Total Column (rowspan=2) -->
                        <ng-container matColumnDef="yearTotal">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Year Total </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{ apeData.yearTotal |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife APE Column -->
                        <ng-container matColumnDef="monthSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthSinglife | currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife Case Column -->
                        <ng-container matColumnDef="monthSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Month Non-Singlife APE Column -->
                        <ng-container matColumnDef="monthNonsinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthNonsinglife |
                                currency: 'SGD'
                                : 'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Non-Singlife Case Column -->
                        <ng-container matColumnDef="monthNonsinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthNonsinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Singlife APE Column -->
                        <ng-container matColumnDef="yearSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearSinglife | currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Singlife Case Column -->
                        <ng-container matColumnDef="yearSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Non-Singlife APE Column -->
                        <ng-container matColumnDef="yearNonsinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearNonsinglife |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Non-Singlife Case Column -->
                        <ng-container matColumnDef="yearNonsinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearNonsinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- First Header Row (with Rep Code, Name, Group Headers, and Year Total) -->
                        <tr mat-header-row *matHeaderRowDef="inceptedApeByAdvisorTableDisplayFirstColumn; sticky: true">
                        </tr>

                        <!-- Second Header Row (with only APE and Case subheaders) -->
                        <tr mat-header-row
                            *matHeaderRowDef="inceptedApeByAdvisorTableDisplaySecondColumn; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: inceptedApeByAdvisorTableDisplayDataRow;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="11">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Incepted APE Data Table Paginator -->
                    <mat-paginator #inceptedApeByAdvisorTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of incepted APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- Incepted APE By Branches-->
    <div id="incepted-ape-by-branch-table-container" class="container-fluid"
        [hidden]="isInceptedApeByBranchTableHidden()">
        <mat-divider class="pias-divider"></mat-divider>
        <mat-accordion>
            <mat-expansion-panel id="incepted-ape-by-branch-table-exapansion-panel" [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title id="incepted-ape-by-branch-table-exapansion-header">
                        <h5 class="page-header">Incepted APE (By branch)</h5>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Incepted APE (By branch) Data Filtering-->
                <!-- <div class="w-100">
                    <mat-form-field class="w-100">
                        <mat-label>Search Incepted APE (By branch)</mat-label>
                        <input matInput [formControl]="inceptedApeByBranchTableFilterFc"
                            (keyup)="__applyInceptedApeByBranchDataFilter()" placeholder="Ex. Branch" #input>
                    </mat-form-field>
                </div> -->
                <div class="position-relative" style="max-width: 500px">
                    <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                        style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeByBranchTableFilterFc"
                        (keyup)="__applyInceptedApeByBranchDataFilter()" placeholder="Search branch..." #input />

                    <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y"
                        style="color: #888888"></i>

                    <button *ngIf="inceptedApeByBranchTableFilterFc.value"
                        class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                        (click)="clearBranchSearch()">
                        <i class="fas fa-times" style="color: #888888"></i>
                    </button>
                </div>
                <hr />

                <!-- Incepted APE Data List table -->
                <div id="incepted-ape-by-branch-table" class="table-scroll-wrapper">
                    <table mat-table [dataSource]="inceptedApeByBranchTableDataSource" matSort matSortDisableClear
                        matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByBranchTableSort="matSort"
                        class="custom-mat-table">

                        <!-- Branch Name Column (rowspan=2) -->
                        <ng-container matColumnDef="branchName">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Branch </th>
                            <td mat-cell *matCellDef="let apeData" style="max-width: 200px;">
                                <a class="branch-popup-link"
                                    (click)="__displayBranchWiseAdvisors(apeData.branchName)">{{apeData.branchName}}</a>
                            </td>
                        </ng-container>

                        <!-- Header Row2 month singlife group -->
                        <ng-container matColumnDef="header-row2-month-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 month nonsinglife group -->
                        <ng-container matColumnDef="header-row2-month-nonsinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Non-Singlife (MTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year singlife group -->
                        <ng-container matColumnDef="header-row2-year-singlife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Header Row2 Year nonsinglife group -->
                        <ng-container matColumnDef="header-row2-year-nonsinglife-group">
                            <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                                Non-Singlife (YTD)
                            </th>
                        </ng-container>

                        <!-- Year Total Column (rowspan=2) -->
                        <ng-container matColumnDef="yearTotal">
                            <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                                class="text-center align-middle fw-bold"> Year Total </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearTotal |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife APE Column -->
                        <ng-container matColumnDef="monthSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthSinglife | currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Singlife Case Column -->
                        <ng-container matColumnDef="monthSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Month Non-Singlife APE Column -->
                        <ng-container matColumnDef="monthNonsinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthNonsinglife |
                                currency: 'SGD'
                                : 'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Month Non-Singlife Case Column -->
                        <ng-container matColumnDef="monthNonsinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthNonsinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Singlife APE Column -->
                        <ng-container matColumnDef="yearSinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearSinglife | currency:
                                'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Singlife Case Column -->
                        <ng-container matColumnDef="yearSinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearSinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- Year Non-Singlife APE Column -->
                        <ng-container matColumnDef="yearNonsinglife">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> APE </th>
                            <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearNonsinglife |
                                currency: 'SGD' :
                                'symbol-narrow' : '1.0-0'}} </td>
                        </ng-container>

                        <!-- Year Non-Singlife Case Column -->
                        <ng-container matColumnDef="yearNonsinglifeCase">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                class="text-center align-middle fw-bold"> Case </th>
                            <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearNonsinglifeCase}}
                            </td>
                        </ng-container>

                        <!-- First Header Row (with Branch, Group Headers, and Year Total) -->
                        <tr mat-header-row
                            *matHeaderRowDef="['branchName', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal']; sticky: true">
                        </tr>

                        <!-- Second Header Row (with only APE and Case subheaders) -->
                        <tr mat-header-row
                            *matHeaderRowDef="['monthSinglife', 'monthSinglifeCase', 'monthNonsinglife', 'monthNonsinglifeCase', 'yearSinglife', 'yearSinglifeCase', 'yearNonsinglife', 'yearNonsinglifeCase']; sticky: true">
                        </tr>

                        <!-- Data Row -->
                        <tr mat-row *matRowDef="let row; columns: inceptedApeByBranchTableDisplayColumn;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="11">No data found.</td>
                        </tr>
                    </table>
                </div>
                <mat-action-row>
                    <!-- Incepted APE Data Table Paginator -->
                    <mat-paginator #inceptedApeByBranchTablePaginator [pageSizeOptions]="[10,20,50]"
                        showFirstLastButtons aria-label="Select page of incepted APE data"></mat-paginator>
                </mat-action-row>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>